module.exports = __webpack_public_path__ + "img/dy_4@2x.b0498e57.png";